<template>
  <v-card>
    <v-card-title>
      Prihlásiť sa do účtu
    </v-card-title>

    <v-card-text>
      <v-form
          @submit.stop.prevent="submit"
      >
        <v-row>
          <v-col
              cols="12"
          >
            <v-text-field
                v-model="UserForm.username"
                :filled="true"
                :dense="true"
                hide-details="auto"
                label="Užívateľské meno"
            />
          </v-col>

          <v-col
              cols="12"
          >
            <v-text-field
                v-model="UserForm.password"
                :filled="true"
                :dense="true"
                hide-details="auto"
                label="Heslo"
                type="password"
            />
          </v-col>

          <v-col
              cols="12"
          >
            Zabudol si heslo?

            <router-link
                to="/request-new-password"
            >
              Vyžiadať nové heslo
            </router-link>
          </v-col>

          <v-col
              cols="12"
          >
            <v-btn
                type="submit"
                :rounded="true"
                :outlined="true"
                :loading="loading"
                :disabled="loading"
                color="primary"
            >
              <v-icon>
                mdi-login
              </v-icon>

              Prihlásiť sa
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import Auth from '@/services/auth'

  export default {
    name: 'Login',
    data() {
      return {
        loading: false,
        UserForm: {}
      }
    },
    metaInfo() {
      return {
        title: 'Prihlásiť sa'
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.loadData()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Prihlásiť sa',
              to: '/login'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.UserForm = {
          username: '',
          password: ''
        }
      },
      async submit() {
        this.loading = true

        await Auth
          .login({
            data: this.UserForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            window.location.reload()
          })
          .catch((error) => {
            switch (error.response.status) {
              case 403:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
